import type {
  CombinedRegistrationStep,
  PropertyRegistrationStep,
  ReservationRegistrationStep,
} from '../interfaces';

export function mergeRegistrationSteps(
  reservationSteps: ReservationRegistrationStep[],
  propertySteps: PropertyRegistrationStep[],
): CombinedRegistrationStep[] {
  if (!reservationSteps?.length || !propertySteps?.length) return [];

  return reservationSteps.reduce<CombinedRegistrationStep[]>((acc, reservationStep) => {
    const matchingPropertyStep = propertySteps.find(
      (propertyStep) =>
        propertyStep.tagId && propertyStep.tagId === reservationStep.tagId,
    );

    if (matchingPropertyStep) {
      acc.push({
        tagId: reservationStep.tagId!,
        name: matchingPropertyStep.name,
        description: matchingPropertyStep.description,
        icon: matchingPropertyStep.icon,
        isSkippable: reservationStep.isSkippable,
        isCompleted: reservationStep.isCompleted,
        reservationRegistrationStepId: reservationStep.reservationRegistrationStepId,
        propertyRegistrationStepId: matchingPropertyStep.propertyRegistrationStepId || '',
      });
    }

    return acc;
  }, []);
}
